import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/colorPicker.tsx
var ColorPicker = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M9.93634 7.13805L16.8621 14.0638M4.28979 15.7528L15.4629 4.57969C16.2356 3.80693 17.4885 3.80693 18.2613 4.57969L19.4204 5.73884C20.1932 6.5116 20.1932 7.76449 19.4204 8.53726L8.24735 19.7103C8.0618 19.8959 7.81015 20.0001 7.54774 20.0001H4.98939C4.44297 20.0001 4 19.5572 4 19.0107V16.4524C4 16.19 4.10424 15.9383 4.28979 15.7528Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeMiterlimit: "10",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.8434 3.64468L11.4036 7.08446L10.5964 6.27726C10.1988 5.87968 9.55421 5.87968 9.15663 6.27726C8.75905 6.67485 8.75905 7.31945 9.15663 7.71704L9.96382 8.52423L3.34637 15.1417C2.96452 15.5235 2.75 16.0414 2.75 16.5815V19.214C2.75 20.3385 3.66161 21.2501 4.78615 21.2501H7.41867C7.95869 21.2501 8.47659 21.0356 8.85844 20.6537L15.4759 14.0363L16.2831 14.8436C16.6807 15.2411 17.3253 15.2411 17.7229 14.8436C18.1205 14.446 18.1205 13.8014 17.7229 13.4038L16.9157 12.5965L20.3554 9.15675C20.5045 9.00766 20.635 8.84699 20.7468 8.67763C21.5296 7.49213 21.3991 5.88109 20.3554 4.83743L19.1627 3.64468C17.9699 2.45193 16.0361 2.45194 14.8434 3.64468ZM11.4036 9.964L14.0361 12.5965L11.4909 15.1417H6.22586L11.4036 9.964Z",
		fill: "currentColor"
	})
});
//#endregion
export { ColorPicker };
